var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center justify-center",class:`pa-${_vm.padding}`},[_c('v-progress-circular',{attrs:{"size":_vm.size,"indeterminate":"","width":2,"color":_vm.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }